import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetPostPreview, EResetPostPreviewActionType } from './types';

export const resetPostPreview: () => TResetPostPreview = actionGenerator<EResetPostPreviewActionType.Reset>(
  EResetPostPreviewActionType.Reset,
);
